import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { MemberNav } from 'Components/widgets/member-nav/MemberNav';
import { capitalizeWordFirstCaracter } from 'Utils/string/stringUtils';
type Props = {
  closeMemberPanel?: () => void;
  userInfo?: UserInfo;
};

const getUserInfo = (userInfo = {}): UserInfoSummary => ({
  firstName:
    userInfo.unicodeFirstName?.trim() || capitalizeWordFirstCaracter(userInfo.firstName?.trim()),
  isLoggedIn: !!userInfo.isLoggedIn,
  isQuickLoggedIn: !!userInfo.isQuickLoggedIn,
  lastName:
    userInfo.unicodeLastName?.trim() || capitalizeWordFirstCaracter(userInfo.lastName?.trim()),
});

export const NavigationMemberAccess = ({ closeMemberPanel, userInfo }: Props) => {
  const { isAppMounted } = useResponsive();

  if (!isAppMounted) {
    return null;
  }

  const userInfos = getUserInfo(userInfo);
  return <MemberNav closeMemberPanel={closeMemberPanel} userInfo={userInfos} />;
};
